export const PET_OPTIONS = [
  { type: 'robot', label: '小机器人' },
  { type: 'cat', label: '猫咪' },
  { type: 'dog', label: '狗狗' },
  { type: 'penguin', label: '企鹅' },
  { type: 'fox', label: '小狐狸' },
]

export function getPetVisual(type) {
  return PET_OPTIONS.find((option) => option.type === type) || PET_OPTIONS[0]
}
